import React, { useState } from "react";
import { Link } from "gatsby";
import { prependLocale } from "../i18n/prepend-locale";
import { cn } from "../util";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <header
        className={cn(
          "fixed left-0 top-0 z-50 flex w-full",
          "items-start py-2 pl-[10px] pr-[10px] xl:pl-6 xl:pr-12",
        )}
      >
        <button
          className={cn(
            "font-formula min-w-[70px] cursor-pointer font-medium",
            "transition-opacity hover:opacity-80",
          )}
          onClick={() => toggleMenu()}
        >
          ( MENÜ )
        </button>
        <nav
          className={cn(
            "ml-[min(4vw,25px)] flex w-full items-center xl:ml-[140px]",
          )}
        >
          <ul
            className={cn(
              "flex items-center gap-[min(4vw,25px)] xl:gap-20",
              "transition-all duration-300",
              isMenuOpen ? "visible opacity-100" : "invisible opacity-0",
            )}
          >
            <li>
              <Link
                to={prependLocale("/#about-section/")}
                className={cn("font-formula font-medium")}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to={prependLocale("/#path-section/")}
                className={cn("font-formula font-medium")}
              >
                The Path
              </Link>
            </li>
            <li className="flex md:hidden">
              <LanguageSwitcher />
            </li>
          </ul>
          <ul className={cn("ml-auto")}>
            <li>
              <Link
                to={prependLocale("/#contact-section/")}
                className={cn("font-formula font-medium")}
              >
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Header;
